module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-beach-a9472682525edd535fdb98e1c170d1fc.svg";